var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_240_440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 69.5C54.2777 69.5 69.5 54.2777 69.5 35.5C69.5 16.7223 54.2777 1.5 35.5 1.5C16.7223 1.5 1.5 16.7223 1.5 35.5C1.5 54.2777 16.7223 69.5 35.5 69.5Z",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_240_440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.574 20.11C51.0897 17.3885 46.848 15.813 42.432 15.6L41.825 16.294C49.197 18.506 52.625 21.758 52.625 21.758C47.2405 18.9079 41.2407 17.4179 35.1485 17.4179C29.0562 17.4179 23.0564 18.9079 17.672 21.758C17.672 21.758 21.228 18.332 29.034 16.12L28.6 15.6C24.1844 15.8185 19.9437 17.3934 16.456 20.11C12.4913 27.8814 10.3549 36.456 10.21 45.179C10.21 45.179 13.853 51.424 23.437 51.727C23.437 51.727 25.037 49.819 26.342 48.171C20.834 46.523 18.753 43.097 18.753 43.097C22.2133 45.2631 26.0549 46.7497 30.072 47.477C37.8582 48.9116 45.8989 47.3468 52.579 43.097C52.579 43.097 50.41 46.61 44.731 48.215C46.031 49.815 47.593 51.684 47.593 51.684C57.176 51.384 60.819 45.136 60.819 45.184C60.6751 36.4593 58.539 27.883 54.574 20.11ZM27.427 41.147C26.2086 41.0986 25.059 40.5693 24.23 39.6751C23.401 38.7809 22.9601 37.5946 23.004 36.376C23.181 30.041 31.718 30.061 31.851 36.376C31.8763 36.9804 31.7816 37.5837 31.5726 38.1513C31.3635 38.7189 31.0441 39.2395 30.6328 39.6831C30.2215 40.1266 29.7265 40.4843 29.1763 40.7356C28.626 40.9869 28.0315 41.1267 27.427 41.147ZM43.256 41.147C42.0376 41.0986 40.888 40.5693 40.059 39.6751C39.23 38.7809 38.7891 37.5946 38.833 36.376C39.028 30.053 47.458 30.05 47.68 36.376C47.7053 36.9804 47.6106 37.5837 47.4016 38.1513C47.1925 38.7189 46.8731 39.2395 46.4618 39.6831C46.0505 40.1266 45.5555 40.4843 45.0053 40.7356C44.455 40.9869 43.8605 41.1267 43.256 41.147Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_240_440",
    x: 4.20996,
    y: 12.6,
    width: 62.6094,
    height: 48.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_240_440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_240_440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_240_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.21a043967cb8a1ac091a0eeb6ddbf198.svg";
export { ForwardRef as ReactComponent };